import { getLocaleFullName, getMomentDate } from '../utils/commonUtils';
export default class SaleOrder {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.groupId = data.groupId || undefined;
        this.quantity = data.quantity || 1;
        // this.surcharge = data.surcharge || 0;
        this.paymentType = data.paymentType || undefined;
        this.saleChannel = data.saleChannel || undefined;
        this.customerId = data.customerId || undefined;
        this.fullname = data.fullname || (data.firstname ? getLocaleFullName(data.firstname, data.lastname) : undefined);
        this.firstname = data.firstname || undefined;
        this.lastname = data.lastname || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.email = data.email || undefined;
        this.note = data.note || undefined;
        this.agentId = data.agentId || undefined;
        this.isSendEmail = data.isSendEmail || undefined;
        this.exportFile = data.exportFile || undefined;
        this.transactionId = data.transactionId || undefined;
        this.tourId = data.tourId || undefined;
        this.tourOrderItems = data.tourOrderItems || [];
        this.bookingDate = getMomentDate(data.bookingDate);
        this.tourOrderItems = data.tourOrderItems || [];
        this.couponCode = data.couponCode || '';
        this.ftCode = data.ftCode || '';
        this.note = data.note || '';
        this.usingDate = data.usingDate || '';
        this.sessionId = data.sessionId || '';
        this.zonePickupId = data.zonePickupId || '';
        this.zoneReleaseId = data.zoneReleaseId || '';
    }

    export() {
        return {
            groupId: this.groupId,
            quantity: this.quantity,
            transactionId: this.transactionId,
            paymentType: this.paymentType,
            saleChannel: this.saleChannel,
            customerId: this.customerId,
            fullname: this.fullname,
            firstname: this.firstname,
            lastname: this.lastname,
            phoneNumber: this.phoneNumber,
            email: this.email,
            note: this.note,
            agentId: this.agentId,
            isSendEmail: this.isSendEmail,
            exportFile: this.exportFile,
            tourId: this.tourId,
            tourOrderItems: this.tourOrderItems,
            couponCode: this.couponCode,
            usingDate: this.usingDate,
            sessionId: this.sessionId,
            zonePickupId: this.zonePickupId,
            zoneReleaseId: this.zoneReleaseId
        }
    }
}